// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"d2bdb520","318":"36935dff","657":"3d7542fc"}[chunkId] + ".chunk.css";
};